import type { NotPricedStatus, PricingStatus } from '@/types/shared'

/**
 * True when the engine writes no prices for the room, so a surface shows why instead of empty cells.
 *
 * Named statuses only, never `status !== 'priced'`: a Same room (combined inventory) reports
 * 'same_room' and is priced, from its twin, so a check against 'priced' alone would call it unpriced.
 * A Same room whose twin has no price reports 'twin_not_priced', and one with no rate plan paired
 * 'plans_not_paired': neither is priced.
 */
export function isNotPriced(status: PricingStatus): status is NotPricedStatus {
  return (
    status === 'missing_base_rate' ||
    status === 'no_active_plans' ||
    status === 'twin_not_priced' ||
    status === 'plans_not_paired'
  )
}
